export default {
    signIn: "ဆိုင်းအင်လုပ်ခြင်း",
    signOut: "ဆိုင်းအောက်",
    enter: "ဝင်ပါ။",
    submit: "တင်ပြပါ။",
    clickToEnter: "Enter ကိုနှိပ်ပါ။"
}